module.exports = __webpack_public_path__ + "static/media/capsule.2420f9cc.png";